import React from 'react';
import { useNavigate } from '@reach/router';

import ga from '~/utils/ga';
import isMobile from '~/utils/is-mobile';

import BG from '~/components/background';

import home from './images/home.png';
import home_2 from './images/home_2.png';

import { HomeWrap } from './styled';

function Supporters() {
  const navigate = useNavigate();

  const isM = isMobile.any();

  /**
   * @description 지원하기 폼으로 이동
   */
  const clickForm = async () => {
    if (isM) return alert('본 이벤트는 웹환경에서만 가능합니다.');
    ga('다방 서포터즈', '지원하기', '서포터즈 지원하기');
    navigate(`/2022/05/supporters/form/`, { replace: true });
  };

  return (
    <HomeWrap>
      <BG width={1280} height={4772} imgUrl={home} />
      <BG width={1280} height={1426} imgUrl={home_2} />
      <button className="home" onClick={clickForm} />
    </HomeWrap>
  );
}

export default Supporters;
